import React from 'react';
import paw from './assets/paw.png';

const styles = {
    container: {
        textAlign: 'center',
        marginTop: '50px',
        fontFamily: "'Libre Baskerville', serif",
        color: '#FBF4DB',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '40px',
        width: '100%',
    },
    lineWrapper: {
        position: 'relative',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    lineText: {
        fontSize: 'clamp(18px, 5vw, 28px)',
        zIndex: 1,
    },
    pawBigRotated: {
        position: 'absolute',
        left: '-75px', // fixed offset to stay visible
        width: '50px',
        height: '50px',
        objectFit: 'contain',
        transform: 'rotate(-80deg)',
    },
};

const HomeIntro = () => {
    return (
        <div style={styles.container}>
            <div style={styles.lineWrapper}>
                <img src={paw} alt="paw" style={styles.pawBigRotated} />
                <span style={styles.lineText}>Help Us On Our Quest to Nome</span>
            </div>
            <div style={{ ...styles.lineWrapper, justifyContent: 'center' }}>
                <span style={styles.lineText}>
                    Each dollar brings us closer to our goal (and love for the dogs carries us the rest of the way)
                </span>
            </div>
        </div>
    );
};

export default HomeIntro;
